<template>
  <section class="period2006-2013wrap" v-parallax v-slide-up-in>
    <v-page :background="theme.colors.cyan">
      <v-chapter-years-title :pageData="info" v-slide-up-in-stage="1" />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-picture-wall :data="paints.data" v-slide-up-in-stage="2" />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <news-picture :newsPicture="newsPicture" />
    </v-page>

    <v-page
      background="images/spread-of-kingdom-gospel/2006-2013/picturesCarouselBg.jpg"
    >
      <persecution-total-section :data="totalOfCapture" />
    </v-page>

    <v-page :background="theme.colors.cyan" class="v-book-2006-2013">
      <v-books :books="books" :showDescOnly="true"/>
    </v-page>

    <v-page :background="theme.colors.cyan">
      <posters :posters="posters" @openVideoPlayer="on_open_player" />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-chatper-entry />
    </v-page>
  </section>
</template>

<script>
import { mapState } from "vuex";

import PersecutionTotalSection from "@/components/persecution-total-section/index.vue";
import Posters from "./components/posters/index.vue";
import NewsPicture from "./components/news-picture/index.vue";

export default {
  computed: {
    ...mapState("global", ["schema"]),
  },
  components: {
    PersecutionTotalSection,
    Posters,
    NewsPicture,
  },
  data() {
    return {
      pageDataItem: {},
      totalOfCapture: {},
      books: "",
      posters: "",
      paints: "",
      info: "",
      newsPicture: [],
    };
  },
  created() {
    this.pageDataItem = this.schema["2006-2013"].item;
    this.info = this.pageDataItem.info;
    this.totalOfCapture = this.pageDataItem.totalOfCapture.data;
    this.books = this.pageDataItem.books;
    this.posters = this.pageDataItem.posters;
    this.paints = this.pageDataItem.paints;
    this.newsPicture = this.pageDataItem.picture.data[0];
  },
  methods: {
    //  打开播放器
    on_open_player(currentVideoInfo) {
      this.$videoPlayer(currentVideoInfo);
    },
  },
};
</script>
